import React from 'react'
import './alert.css'
class AuthenticationAlert extends React.Component{
	constructor(props){
		super(props)
	}
	render(){
		return(
			<div className="return-role-notice">
			   <span className="return-role-title ">光明勇士账号鉴定规则：</span>
					
			   <span>1、认证手机下手游账号超过14天未登录任何手机游戏；</span>
			   <span>2、当年回归登录光明勇士游戏。</span>
		    </div>
			)

	}
}
export default AuthenticationAlert




// WEBPACK FOOTER //
// ./src/component/return-get-alert/authentication-alert-7910.js